// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Oij7b{line-height:1.2;margin-top:32px;text-align:center}._2Sqis{margin:0 auto 3rem}._2Sqis,._124sw{height:60px;height:6rem;position:relative;width:60px;width:6rem}._124sw{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#c9cfdc;border-radius:8px;justify-content:center;overflow:hidden}.O5KvW{max-height:100%;width:auto}._2nWij{color:#fff;display:block;font-size:32px;font-size:3.2rem;font-weight:700}._3cwTE{color:#30a8ff;font-size:24px;font-size:2.4rem;font-weight:700;padding:3rem 0}@media (min-width:1024px){._3cwTE{font-size:3.6rem}}._1AnOV{font-size:16px;font-size:1.6rem}", ""]);
// Exports
exports.locals = {
	"root": "Oij7b",
	"avatar": "_2Sqis",
	"avatar__imgWrapper": "_124sw",
	"avatar__img": "O5KvW",
	"avatar__initials": "_2nWij",
	"clinicName": "_3cwTE",
	"info": "_1AnOV"
};
module.exports = exports;
